import { useLocation } from 'react-router-dom';

const useQueryParams = (params: string[]): Record<string, string | null> => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const result: Record<string, string | null> = {};
  params.forEach((param) => {
    result[param] = searchParams.get(param);
  });

  return result;
};

export default useQueryParams;
